<template>
  <q-dialog v-model="isOpen" persistent @hide="citySync = null">
    <q-card>
      <q-card-section>
        <h6>Change Operation City & Price Set</h6>
      </q-card-section>

      <q-card-section>
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <q-input v-model="citySync.name" disable label="City" />
          </div>

          <div class="col-12 col-md-6">
            <q-input v-model="citySync.subscriptionPrice" disable label="Subscription" prefix="$" />
          </div>

          <div class="col-12 col-md-6">
            <q-input v-model="citySync.rfqSentPrice" disable label="RFQ Sent" prefix="$" />
          </div>

          <div class="col-12 col-md-6">
            <q-input v-model="citySync.bookingReceivedPrice" disable label="Booking Received" prefix="$" />
          </div>

          <div class="col-12 col-md-6">
            <q-input v-model="citySync.commissionRate" disable label="Commission" suffix="%" />
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="muted" label="Cancel" :disable="isLoading" />
        <q-btn color="primary" label="Save" :loading="isLoading" @click="updateCity" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import decimal from 'vuelidate/lib/validators/decimal';
import minValue from 'vuelidate/lib/validators/minValue';
import maxValue from 'vuelidate/lib/validators/maxValue';
import API from '@/apis';
import { getErrorMessage } from '@/utils';

export default {
  props: {
    city: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: true,
      isLoading: false,
    };
  },

  computed: {
    citySync: {
      get() {
        return this.city;
      },
      set(val) {
        return this.$emit('update:city', val);
      },
    },
  },

  methods: {
    async updateCity() {
      // this.$v.$reset();
      // this.$v.$touch();

      // if (this.$v.$invalid) return;

      try {
        this.isLoading = true;

        const { data } = await this.$axios.request(API.city.update(this.citySync));

        this.$q.notify({ message: 'City updated', type: 'positive' });
        this.$emit('updated', data);
        this.isOpen = false;
      } catch (error) {
        this.$q.notify({ message: getErrorMessage(error), type: 'negative' });
      } finally {
        this.isLoading = false;
      }
    },
  },

  validations: {
    citySync: {
      commissionRate: {
        required,
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(100),
      },
    },
  },
};
</script>
